import { Column } from '~components/table-view';
import dayjs, { datePickerDisplayFormat } from '~libs/dayjs';

export const dexIssueColumns: Column[] = [
  { id: 'appointment_id', header: 'Appt ID', type: 'text', style: { width: '90px' } },
  { id: 'client_name', header: 'Client', type: 'text' },
  {
    id: 'date',
    header: 'Date',
    type: 'text',
    style: { width: '110px' },
    deriveValue: (row) => (row.date ? dayjs(row.date).format(datePickerDisplayFormat) : ''),
  },
  { id: 'reason', header: 'Reason', type: 'text' },
];

export const dexSessionColumns: Column[] = [
  {
    id: 'appointment_id',
    header: 'Appt ID',
    caption: 'Sent to DEX as the Session ID',
    type: 'text',
    style: { width: '90px' },
  },
  {
    id: 'date',
    header: 'Date',
    type: 'text',
    style: { width: '110px' },
    deriveValue: (row) => (row.date ? dayjs(row.date).format(datePickerDisplayFormat) : ''),
  },
  { id: 'client_name', header: 'Client', type: 'text' },
  {
    id: 'client_dex_id',
    header: 'DEX Client ID',
    caption: 'The Client ID this session is reported under',
    type: 'text',
  },
  { id: 'service_type_name', header: 'Service Type', type: 'text' },
  {
    id: 'package_name',
    header: 'Package',
    caption: "Client's support package name (not the DEX case ID)",
    type: 'text',
  },
  { id: 'case_id', header: 'Case ID', caption: 'The DEX Case ID this session is reported under', type: 'text' },
];
